import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { showHideOrganisationalUnitAddUsersModal } from 'actions/modal.js';
import { clearSearchUserForm } from 'actions/user.js';
import { previousPage } from 'actions/navigationBar';
import EmailUsersButton from '../../../shared/email-users-button/content';

export default function RightPanelOrTopPanel(props) {
  const dispatch = useDispatch();
  const [extendContent, setExtendContent] = useState(false);

  useEffect(() => {
    var clipboard = new window.Clipboard('.copy-to-clipboard-email-all-users');
    clipboard.on('success', function (e) {
      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);
      e.clearSelection();
    });
  }, []);

  const openAddUserModal = () => {
    if (!areOrganisationalUnitUsersLoaded()) return;
    dispatch(clearSearchUserForm());
    dispatch(showHideOrganisationalUnitAddUsersModal(true));
  };

  const areOrganisationalUnitUsersLoaded = () => {
    return !props.fetchingUserICanManage && props.usersIcanManage;
  };

  const areOrganisationalUnitUsersAvailable = () => {
    return areOrganisationalUnitUsersLoaded() && props.usersIcanManage.length > 0;
  };

  const buttonsForDesktop = (
    <div>
      <button
        type="button"
        className={`ui labeled icon button mrbs color-button color-white right-hand-side-button ${
          !areOrganisationalUnitUsersLoaded() ? 'disable' : ''
        }`}
        onClick={openAddUserModal}
      >
        <i className="plus icon" />
        {APP.LANGUAGE.OrganisationalUnitManageUsers.AddUserButtonText}
      </button>

      <EmailUsersButton
        userEmails={props.selectedOrgUsersEmail}
        dispatch={dispatch}
        isUsersAvailable={areOrganisationalUnitUsersAvailable()}
        entityName={props.organisationalUnit.name}
        areUsersLoaded={areOrganisationalUnitUsersLoaded}
        isDesktop={true}
        handleOpen={() => {
          setExtendContent(true);
        }}
        handleClose={() => {
          setExtendContent(false);
        }}
      />
    </div>
  );

  const buttonsForTablet = (
    <div>
      <button
        className={`ui labeled icon button color-button color-white right-hand-side-button mrrsss ${
          !areOrganisationalUnitUsersLoaded() ? 'disable' : ''
        }`}
        onClick={openAddUserModal}
      >
        <i
          className="plus icon"
          ref={(el) => {
            if (el) {
              el.style.setProperty('font-size', '1em', 'important');
            }
          }}
        />
        {APP.LANGUAGE.OrganisationalUnitManageUsers.AddUserButtonText}
      </button>

      <EmailUsersButton
        userEmails={props.selectedOrgUsersEmail}
        dispatch={dispatch}
        isUsersAvailable={areOrganisationalUnitUsersAvailable()}
        entityName={props.organisationalUnit.name}
        areUsersLoaded={areOrganisationalUnitUsersLoaded()}
        isTab={true}
        handleOpen={() => {
          setExtendContent(true);
        }}
        handleClose={() => {
          setExtendContent(false);
        }}
      />
    </div>
  );

  const buttonsForMobile = (
    <div>
      <button
        className={`ui icon button color-button color-white mrrsss mrbml ${
          !areOrganisationalUnitUsersLoaded() ? 'disable' : ''
        }`}
        onClick={openAddUserModal}
      >
        <i className="plus icon" />
      </button>

      <EmailUsersButton
        userEmails={props.selectedOrgUsersEmail}
        dispatch={dispatch}
        isUsersAvailable={areOrganisationalUnitUsersAvailable}
        entityName={props.organisationalUnit.name}
        areUsersLoaded={areOrganisationalUnitUsersLoaded}
        isMobile={true}
        handleOpen={() => {
          setExtendContent(true);
        }}
        handleClose={() => {
          setExtendContent(false);
        }}
      />
    </div>
  );
  return (
    <div style={{ height: '100%' }}>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '100%' }}>
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdtxl pdbm pdrm logo-on-right-hand">
            <img className="ui image pdtxs umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo.default} />
            <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo.default} />
          </div>
          <div className="pdbs pdll pdrm">{buttonsForDesktop}</div>
          <div className="pdbm pdrm pdlm">{props.bottomSession}</div>
        </div>
      </Container>
      <Container fluid as={Media} at="tablet">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdlm pdrm">{buttonsForTablet}</div>
          <div className="mrts pdts mrbm">
            <Link
              className="back-to-org-link left-text pdlm pdbs"
              to={`/organisational-unit/view-all`}
              onClick={() => {
                dispatch(previousPage(APP.LANGUAGE.OrganisationalUnitManageUsers.PageHeaderTitle));
              }}
            >
              <i className="chevron circle left icon" />
              <span>{APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText}</span>
            </Link>
          </div>
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdlm pdrm">{buttonsForMobile}</div>
          <div className="pdtxs mrbs">
            <Link
              className="back-to-org-link left-text pdlm pdbs"
              to={`/organisational-unit/view-all`}
              onClick={() => {
                dispatch(previousPage(APP.LANGUAGE.OrganisationalUnitManageUsers.PageHeaderTitle));
              }}
            >
              <i className="chevron circle left icon" />
              <span>{APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText}</span>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
}

RightPanelOrTopPanel.propTypes = {
  organisationalUnit: PropTypes.object.isRequired,
  availableRoles: PropTypes.array,
  usersIcanManage: PropTypes.array.isRequired,
  fetchingUserICanManage: PropTypes.bool,
};
